// todo the schema should be a module we import from the backend
// ! never npx drizzle-kit push this!!!
// ! never npx drizzle-kit push this!!!
// ! never npx drizzle-kit push this!!!
// ! the actual schema is in the backend project, we only need this for the types
import {
  bigint,
  boolean,
  char,
  date,
  datetime,
  decimal,
  double,
  index,
  int,
  json,
  longtext,
  mysqlEnum,
  mysqlTable,
  serial,
  smallint,
  text,
  timestamp,
  tinyint,
  varchar,
  year,
} from 'drizzle-orm/mysql-core';

export const docNotifications = mysqlTable('doc_notifications', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  document_id: varchar('document_id', { length: 191 }).notNull(),
  document_title: varchar('document_title', { length: 255 }).notNull(),
  notify_at: timestamp('notify_at', { mode: 'string' }).defaultNow(),
  sent: tinyint('sent').default(0),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const documents = mysqlTable('documents', {
  id: serial('id').primaryKey().notNull(),
  cloud_id: char('cloud_id', { length: 36 }).notNull(),
  name: text('name'),
  location: char('location', { length: 16 }),
  docomondoId: int('docomondoId'),
  adapterPDFId: text('adapterPDFId'),
  adapterRootFolderId: text('adapterRootFolderId'),
  adapterThumbnailSmallId: text('adapterThumbnailSmallId'),
  tags: longtext('tags'),
  isTaxRelated: tinyint('isTaxRelated'),
  issuer: text('issuer'),
  // todo migrate to decimal
  //DECIMAL(10,2) can store values between -99,999,999.99 and 99,999,999.99.  <-- this should be enough stored as 5 bytes
  //DECIMAL(19,4) can store values between -999,999,999,999,999.9999 and 999,999,999,999,999.9999. <-- probably overkill, stored as 9 bytes
  amount: double('amount', { precision: 16, scale: 2 }),
  currency: text('currency'),
  comment: text('comment'),
  ocr: text('ocr'),
  docCreatedTime: timestamp('docCreatedTime', { mode: 'string' }),
  issueDateDefault: timestamp('issueDateDefault', { mode: 'string' }),
  issueDate: timestamp('issueDate', { mode: 'string' }),
  dueDate: timestamp('dueDate', { mode: 'string' }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
  meta: longtext('meta'),
  dataPointDetails: text('dataPointDetails'),
  iconIndex: int('iconIndex').default(1).notNull(),
});

export const events = mysqlTable('events', {
  id: serial('id').primaryKey().notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  identifier: varchar('identifier', { length: 191 }).notNull(),
  value: text('value'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const jobs = mysqlTable(
  'jobs',
  {
    id: serial('id').primaryKey().notNull(),
    queue: varchar('queue', { length: 191 }).notNull(),
    payload: longtext('payload').notNull(),
    attempts: tinyint('attempts').notNull(),
    reserved_at: int('reserved_at'),
    available_at: int('available_at').notNull(),
    created_at: int('created_at').notNull(),
  },
  (table) => {
    return {
      queueIdx: index('queue').on(table.queue),
    };
  },
);

export const logs = mysqlTable('logs', {
  id: serial('id').primaryKey().notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  title: text('title'),
  message: longtext('message'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const passwordResets = mysqlTable(
  'password_resets',
  {
    email: varchar('email', { length: 191 }).primaryKey().notNull(),
    token: varchar('token', { length: 191 }).notNull(),
    created_at: timestamp('created_at', { mode: 'string' }),
  },
  (table) => {
    return {
      emailIdx: index('password_resets_email_index').on(table.email),
    };
  },
);

export const userDoc = mysqlTable('user_doc', {
  id: serial('id').primaryKey().notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  doc_id: bigint('doc_id', { mode: 'number' }).notNull(),
  role: text('role').notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const userMeta = mysqlTable(
  'user_meta',
  {
    id: serial('id').primaryKey().notNull(),
    user_id: bigint('user_id', { mode: 'number' }).notNull(),
    key: text('key').notNull(),
    value: text('value'),
    created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
    updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
  },
  (table) => {
    return {
      userIdIdx: index('user_id').on(table.user_id),
    };
  },
);

export const users = mysqlTable('users', {
  id: serial('id').primaryKey().notNull(),
  uuid: char('uuid', { length: 36 }).notNull(),
  clerk_id: char('clerk_id', { length: 36 }),
  intercom_id: varchar('intercom_id', { length: 191 }),
  name: varchar('name', { length: 191 }),
  last_name: varchar('last_name', { length: 191 }),
  email: varchar('email', { length: 191 }).notNull(),
  email_verified_at: timestamp('email_verified_at', { mode: 'string' }).defaultNow(),
  password: varchar('password', { length: 191 }).notNull(),
  api_token: varchar('api_token', { length: 80 }),
  google2fa_secret: text('google2fa_secret'),
  remember_token: varchar('remember_token', { length: 100 }),
  doc_id: int('doc_id', { unsigned: true }).default(0).notNull(),
  reminder_time: varchar('reminder_time', { length: 191 }).default('morning').notNull(),
  reminder_locale: mysqlEnum('reminder_locale', ['de', 'en']),
  iban: varchar('iban', { length: 34 }),
  trial_notification_at: timestamp('trial_notification_at', { mode: 'string' }),
  subscription_teaser_at: timestamp('subscription_teaser_at', {
    mode: 'string',
  }),
  gdrive_access_token: longtext('gdrive_access_token'),
  gdrive_refresh_token: longtext('gdrive_refresh_token'),
  gdrive_token_expires_at: timestamp('gdrive_token_expires_at', {
    mode: 'string',
  }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
  deleted_at: timestamp('deleted_at', { mode: 'string' }),
});

export const organizations = mysqlTable('organizations', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  name: char('name', { length: 36 }).notNull(),
  slug: char('slug', { length: 36 }),
  default_cost_centre_id: bigint('default_cost_centre_id', { mode: 'number' }),
  default_currency: char('default_currency', { length: 3 }),
  default_country: char('default_country', { length: 2 }),
  overdue_days: smallint('overdue_days').notNull().default(30),
  recipients: json('recipients'),
  created_by: char('created_by', { length: 36 }),
  per_km_expense_rate: decimal('per_km_expense_rate', { precision: 10, scale: 2 }).default('1.00'),
  subscription_status: mysqlEnum('subscription_status', [
    'active',
    'past_due',
    'canceled',
    'unpaid',
    'trialing',
  ]),
  next_invoice_date: timestamp('next_invoice_date', { mode: 'string' }),
  cancel_at: timestamp('cancel_at', { mode: 'string' }),
  stripe_subscription_id: varchar('stripe_subscription_id', { length: 255 }),
  stripe_customer_id: varchar('stripe_customer_id', { length: 255 }),
  seat_count: smallint('seat_count').notNull().default(0),
  conversion_tracked: boolean('conversion_tracked').notNull().default(false),
  form_field_settings: json('form_field_settings'),
  default_paid_with_personal_funds: boolean('default_paid_with_personal_funds')
    .notNull()
    .default(false),
  company_setup_status: mysqlEnum('company_setup_status', ['pending', 'done'])
    .notNull()
    .default('done'),
  company_setup_steps: json('company_setup_steps'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
  deleted_at: timestamp('deleted_at', { mode: 'string' }),
});

export const transactions = mysqlTable('transactions', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  creditcard_id: bigint('creditcard_id', { mode: 'number' }).notNull(),
  raw: json('raw'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const creditcards = mysqlTable('creditcards', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  cardReference: char('cardReference', { length: 36 }).notNull(),
  cardLastNumbers: char('cardLastNumbers', { length: 4 }).notNull(),
  name: char('name', { length: 191 }).notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const memberships = mysqlTable('memberships', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  clerk_id: char('clerk_id', { length: 36 }).notNull(),
  organization_id: char('organization_id', { length: 36 }).notNull(),
  role: mysqlEnum('role', ['basic_member', 'admin']).notNull().default('basic_member'),
  hide_company_setup_banner: boolean('hide_company_setup_banner').notNull().default(false),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const expenses = mysqlTable(
  'expenses',
  {
    id: serial('id').primaryKey().notNull().autoincrement(),
    uuid: char('uuid', { length: 36 }).notNull().unique(),
    transaction_id: bigint('transaction_id', { mode: 'number' }),
    user_id: bigint('user_id', { mode: 'number', unsigned: true }).notNull(),
    organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
    reports_id: bigint('reports_id', { mode: 'number' }),
    creditcard_id: bigint('creditcard_id', { mode: 'number' }),
    date: datetime('date', { mode: 'string' }).notNull(),
    title: char('title', { length: 64 }),
    issuer: char('issuer', { length: 64 }),
    category_id: bigint('category_id', { mode: 'number' }),
    country: char('country', { length: 2 }),
    amount: decimal('amount', { precision: 10, scale: 2 }).notNull(),
    currency: char('currency', { length: 3 }).notNull(),
    amount_default_currency: decimal('amount_default_currency', {
      precision: 10,
      scale: 2,
    }).notNull(),
    default_currency: char('default_currency', { length: 3 }).notNull(),
    vat: decimal('vat', { precision: 4, scale: 2 }),
    client_id: bigint('client_id', { mode: 'number' }),
    cost_centre_id: bigint('cost_centre_id', { mode: 'number' }),
    comment: text('comment'),
    isPrivateExpense: tinyint('isPrivateExpense').default(0).notNull(),
    isPaidWithPersonalFunds: tinyint('isPaidWithPersonalFunds').default(0).notNull(),
    hasReceipt: tinyint('hasReceipt').default(0).notNull(),
    isBillable: tinyint('isBillable'),
    warnings: text('warnings'), //should use json
    status: mysqlEnum('status', [
      'open',
      'approving',
      'approved',
      'overdue',
      'rejected',
      'done',
    ])
      .notNull()
      .default('open'),
    settlement_transaction_id: bigint('settlement_transaction_id', { mode: 'number' }), // add index for this column
    created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
    updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
  },
  (table) => ({
    settlement_transaction_id_index: index('settlement_transaction_id_idx').on(
      table.settlement_transaction_id,
    ),
  }),
);

export const mileages = mysqlTable('mileages', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  user_id: bigint('user_id', { mode: 'number', unsigned: true }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  reports_id: bigint('reports_id', { mode: 'number' }),
  date: datetime('date', { mode: 'string' }).notNull(),
  amount_default_currency: decimal('amount_default_currency', {
    precision: 10,
    scale: 2,
  }).notNull(),
  distance: decimal('distance', { precision: 10, scale: 1 }),
  distanceCalculated: decimal('distanceCalculated', {
    precision: 10,
    scale: 1,
  }).notNull(),
  default_currency: char('default_currency', { length: 3 }).notNull(),
  client_id: bigint('client_id', { mode: 'number' }),
  cost_centre_id: bigint('cost_centre_id', { mode: 'number' }),
  isBillable: tinyint('isBillable'),
  route: text('route'), // [ name: Schaan, coordinates { lat: 123, lng: 123 }, ...]
  comment: text('comment'),
  warnings: text('warnings'), //should use json
  status: mysqlEnum('status', [
    'open',
    'approving',
    'approved',
    'overdue',
    'rejected',
    'done',
  ])
    .notNull()
    .default('open'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const mileagesHistory = mysqlTable('mileages_history', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  mileage_id: bigint('mileage_id', { mode: 'number' }),
  user_id: bigint('user_id', { mode: 'number' }),
  key: mysqlEnum('key', [
    'status',
    'comment',
    'comment_field',
    'amount_default_currency',
    'date',
    'distance',
    'client',
    'cost_centre',
    'route',
    'isBillable',
  ]).notNull(),
  old_value: text('old_value'),
  new_value: text('new_value'),
  comment: char('comment', { length: 64 }),
  role: text('role'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
});

export const expensesHistory = mysqlTable('expenses_history', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  expense_id: bigint('expense_id', { mode: 'number' }),
  user_id: bigint('user_id', { mode: 'number' }),
  key: mysqlEnum('key', [
    'status',
    'comment',
    'comment_field',
    'amount',
    'amount_default_currency',
    'currency',
    'date',
    'title',
    'issuer',
    'category',
    'country',
    'vat',
    'client',
    'cost_centre',
    'isBillable',
    'splits',
    'hasReceipt',
  ]).notNull(),
  old_value: text('old_value'),
  new_value: text('new_value'),
  comment: char('comment', { length: 64 }),
  role: text('role'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
});

export const reports = mysqlTable('reports', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  title: char('title', { length: 64 }).notNull(),
  description: char('description', { length: 64 }).notNull(),
  status: mysqlEnum('status', [
    'open',
    'approving',
    'approved',
    'overdue',
    'rejected',
    'done',
  ])
    .notNull()
    .default('open'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const categories = mysqlTable('categories', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  enabled: tinyint('enabled').default(1).notNull(),
  uuid: char('uuid', { length: 36 }).notNull(),
  cost_type: bigint('cost_type', { mode: 'number' }),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  title: char('title', { length: 64 }).notNull(),
  key: char('key', { length: 64 }),
  description: char('description', { length: 64 }),
  isModified: tinyint('isModified').default(0).notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const clients = mysqlTable('clients', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  name: char('name', { length: 64 }).notNull(),
  reference: char('reference', { length: 64 }),
  deleted: tinyint('deleted').notNull().default(0),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const costcentres = mysqlTable('costcentres', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  organization_id: bigint('organization_id', { mode: 'number' }).notNull(),
  name: char('name', { length: 64 }).notNull(),
  reference: char('reference', { length: 64 }),
  is_deleted: boolean('is_deleted').notNull().default(false),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const rules = mysqlTable('rules', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  category_id: bigint('category_id', { mode: 'number' }),
  organization_id: char('organization_id', { length: 36 }).notNull(),
  // key: char('key', { length: 16 }).notNull(),
  key: mysqlEnum('key', [
    'comment',
    'amount_daily',
    'amount_monthly',
    'receipt',
    'distance',
    'issuer',
    'category',
    'vat',
    'client',
    'cost_centre',
    'country',
    'report',
  ]).notNull(),
  value: decimal('value', { precision: 10, scale: 2 }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const budgets = mysqlTable('budgets', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  category: varchar('category', { length: 64 }).notNull(),
  repeat: mysqlEnum('repeat', ['monthly', 'once']).notNull(),
  value: double('value', { precision: 16, scale: 2 }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const goals = mysqlTable('goals', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  value: double('value', { precision: 16, scale: 2 }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const defaultAccounts = mysqlTable('defaultAccounts', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  name: char('name', { length: 64 }).notNull(),
  logo: char('logo', { length: 64 }).notNull(),
  type: mysqlEnum('type', ['bank', 'creditcard']).notNull().default('bank'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const providers = mysqlTable('provider', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  provider_id: bigint('provider_id', { mode: 'number' }).notNull().unique(),
  name: varchar('name', { length: 191 }).notNull(),
  logo_url: varchar('logo_url', { length: 191 }).notNull(),
  home_url: varchar('home_url', { length: 191 }).notNull(),
  login_url: varchar('login_url', { length: 191 }).notNull(),
  status: mysqlEnum('status', ['active', 'inactive', 'disabled']).notNull().default('active'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).notNull().defaultNow().onUpdateNow(),
});

export const user_saltedge = mysqlTable('user_saltedge', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  customer_id: bigint('customer_id', { mode: 'bigint' }).notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const connections = mysqlTable('connections', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  provider_id: bigint('provider_id', { mode: 'number' }).notNull(),
  provider_name: varchar('provider_name', { length: 191 }).notNull(),
  connection_id: bigint('connection_id', { mode: 'bigint' }).notNull(),
  status: mysqlEnum('status', ['active', 'inactive', 'disabled']).notNull().default('active'),
  last_update: timestamp('last_update', { mode: 'string' }),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const accounts = mysqlTable('accounts', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  account_id: bigint('account_id', { mode: 'bigint' }).notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  connection_id: bigint('connection_id', { mode: 'number' }).notNull(), // key to connections.id
  provider_id: bigint('provider_id', { mode: 'number' }).notNull(),
  name: varchar('name', { length: 64 }).notNull(),
  balance: double('balance', { precision: 16, scale: 2 }).notNull(),
  currency_code: char('currency_code', { length: 3 }).notNull(),
  nature: mysqlEnum('nature', [
    'account',
    'bonus',
    'card',
    'checking',
    'credit',
    'credit_card',
    'debit_card',
    'ewallet',
    'insurance',
    'investment',
    'loan',
    'mortgage',
    'savings',
  ])
    .notNull()
    .default('account'),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).notNull().defaultNow(),
});

export const userAccounts = mysqlTable('userAccounts', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  provider_id: bigint('provider_id', { mode: 'number' }).notNull(),
  description: char('description', { length: 64 }).notNull(),
  balance: double('balance', { precision: 16, scale: 2 }).notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).defaultNow().onUpdateNow(),
});

export const accountSnapshots = mysqlTable('accountSnapshots', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  account_id: bigint('account_id', { mode: 'bigint' }).notNull(),
  balance: double('balance', { precision: 16, scale: 2 }).notNull(),
  month: tinyint('month').notNull(),
  year: year('year').notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).notNull().defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).notNull().defaultNow().onUpdateNow(),
});

export const transactionsBudget = mysqlTable('transactionsBudget', {
  id: serial('id').primaryKey().notNull().autoincrement(),
  uuid: char('uuid', { length: 36 }).notNull(),
  user_id: bigint('user_id', { mode: 'number' }).notNull(),
  transaction_id: bigint('transaction_id', { mode: 'bigint' }),
  connection_id: bigint('connection_id', { mode: 'bigint' }),
  account_id: bigint('account_id', { mode: 'bigint' }),
  description: varchar('description', { length: 191 }),
  category: varchar('category', { length: 64 }),
  issuer: char('issuer', { length: 64 }),
  amount: double('amount', { precision: 16, scale: 2 }).notNull(),
  currency_code: char('currency_code', { length: 3 }).notNull(),
  status: mysqlEnum('status', ['posted', 'pending']).notNull(),
  made_on: date('made_on', { mode: 'string' }).notNull(),
  created_at: timestamp('created_at', { mode: 'string' }).notNull().defaultNow(),
  updated_at: timestamp('updated_at', { mode: 'string' }).notNull().defaultNow().onUpdateNow(),
});
